import { RhinoError } from '../../../error';

import { settingsMap } from './getChannelsSettings';

export function createWrongChannelCategoryType() {
  const supportedTypes = Object.keys(settingsMap).join(', ');

  return new RhinoError(
    'RUNTIME',
    `The category items associated with the provided referenceId doesn't match any of ${supportedTypes}`,
  );
}
